/* JavaScript extraído dos blocos Custom Liquid dos templates de produto. */

/* Duplica a lista para loop perfeito (50% + 50%) e ajusta a velocidade via data-speed */
document.addEventListener('DOMContentLoaded', function(){
  const track = document.getElementById('maritaTicker');
  if(!track) return;

  // clona conteúdo para poder animar contínuo
  const clone = track.cloneNode(true);
  clone.id = ''; // sem id duplicado
  track.parentNode.appendChild(clone);

  // velocidade opcional pelo atributo data-speed (em segundos)
  const sec = document.querySelector('.marita-ticker');
  const speed = parseFloat(sec?.getAttribute('data-speed') || '26');
  const tracks = sec.querySelectorAll('.marita-ticker__track');
  tracks.forEach(t => t.style.animationDuration = speed + 's');
});

document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('marita-rotator-30');
  if (!section) return;

  const words = Array.from(section.querySelectorAll('.word'));
  if (!words.length) return;

  let i = 0, timer = null;
  const DURATION = 2400;

  const show = (idx) => {
    words.forEach(w => w.classList.remove('is-active'));
    words[idx].classList.add('is-active');
  };

  const start = () => {
    if (timer) return;
    timer = setInterval(() => {
      i = (i + 1) % words.length;
      show(i);
    }, DURATION);
  };
  const stop = () => { clearInterval(timer); timer = null; };

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => e.isIntersecting ? (show(i), start()) : stop());
  }, { threshold: 0.2 });
  io.observe(section);

  document.addEventListener('visibilitychange', () => {
    document.hidden ? stop() : start();
  });
});


(() => {
  const el=document.getElementById('miCard');
  if(!el)return;
  if(!('IntersectionObserver'in window)){el.classList.add('mi-show');return;}
  const io=new IntersectionObserver(([e])=>{
    if(e.isIntersecting){el.classList.add('mi-show');io.disconnect();}
  },{threshold:0.2});
  io.observe(el);
})();
